import type { ToastErrorPayload } from '@/lib/format-api-error'
import { ApiError } from '@/lib/api'
import { resolveApiErrorMessage } from '@/lib/api-error-messages'
import { formatApiError } from '@/lib/format-api-error'

// Builds a sonner toast payload for a mutation error (user management, product
// create/update, ...).
// Title: the localized message from the single error-i18n owner for a known
// error code, otherwise the caller's Vietnamese fallback label. Description:
// the stable error code + request ID (via formatApiError) so an admin can quote
// it and support can grep the logs.
export function userErrorToast(
    err: unknown,
    fallback: string,
): ToastErrorPayload {
    const { description } = formatApiError(err, fallback)
    const mapped =
        err instanceof ApiError
            ? resolveApiErrorMessage(err.code, err.params)
            : null
    return { title: mapped || fallback, description }
}
